export const CHANGE_STATUS = 'operator/CHANGE_STATUS';
export const RECEIVE_BILLING_MESSAGE = 'operator/RECEIVE_BILLING_MESSAGE';

export const changeStatus = status => ({
  type: CHANGE_STATUS,
  payload: status,
});

export const receiveBillingMessage = message => ({
  type: RECEIVE_BILLING_MESSAGE,
  payload: message,
});
